"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyService = void 0;
const CompanyServiceStub_1 = require("./CompanyServiceStub");
const CompanyServiceLive_1 = require("./CompanyServiceLive");
class CompanyService {
    static create(stub) {
        if (stub) {
            return new CompanyServiceStub_1.CompanyServiceStub();
        }
        return new CompanyServiceLive_1.CompanyServiceLive();
    }
}
exports.CompanyService = CompanyService;
//# sourceMappingURL=CompanyService.js.map